import { useCallback, useMemo } from 'react';
import { JUMP_SECONDS } from '../constants';
import { useRemotionPlayerCurrentTime } from '@/App/remotion/MainPlayer/ClipPlayerV2WithNewTimeline/hooks/useRemotionPlayerCurrentTime';
import { useRemotionPlayerSeek } from '@/App/remotion/MainPlayer/ClipPlayerV2WithNewTimeline/hooks/useRemotionPlayerSeek';
import useRemotionPlayerDuration from '@/App/remotion/MainPlayer/ClipPlayerV2WithNewTimeline/hooks/useRemotionPlayerDuration';

export const usePlaybackJumpNavigation = () => {
  const { currentTime } = useRemotionPlayerCurrentTime();
  const { seekTo } = useRemotionPlayerSeek();
  const duration = useRemotionPlayerDuration();

  const onJumpBackward = useCallback(() => {
    seekTo(Math.max(0, currentTime - JUMP_SECONDS));
  }, [currentTime, seekTo]);

  const onJumpForward = useCallback(() => {
    seekTo(Math.min(duration, currentTime + JUMP_SECONDS));
  }, [currentTime, duration, seekTo]);

  const isJumpBackwardDisabled = useMemo(() => currentTime <= 0, [currentTime]);
  const isJumpForwardDisabled = useMemo(() => currentTime >= duration, [currentTime, duration]);

  return {
    onJumpBackward,
    onJumpForward,
    isJumpBackwardDisabled,
    isJumpForwardDisabled
  };
};
